import { schema } from "normalizr";
import { servicesTypes } from "../types";
import Resource from "./resource";

const servicesSchema = new schema.Entity("services");

export default new Resource("/services", servicesTypes, servicesSchema);
